import { visitarPágina } from './Reflinks'
import { fecharModais, fecharÚltimoModal, recarregarÚltimoModal, fecharModaisDeEdição, abrirModalUrl } from './Modal'
import { próximoChangeset } from './Reflinks'
import { toast } from './Toast'
import { mobile } from '@Shared/Device'

/**
 * O changeset é o recurso usado para que o backend possa controlar o front-end.
 * Um fluxo bem comum é o de criação de registro, onde a pessoa envia os dados do formulário,
 * o servidor faz o que precisa fazer e retorna com um redirect.
 *
 * Redirecionar é talvez o exemplo mais comum onde o backend controla o frontend, mas existem outras ações:
 *
 * - Fechar o último modal
 * - Recarregar a página atual limpando os filtros
 * - Emitir um evento
 * - Mostrar um toast de sucesso ou falha (flash)
 *
 * @param {*} changeset
 */
export async function aplicarChangeset(changeset) {
    if (!changeset.ações) return

    let ações = changeset.ações
    let mergedJson = {}

    let açõesCustomizadas = próximoChangeset()
    if (açõesCustomizadas) {
        let json = ações.find(a => a.json)
        mergedJson = { ...mergedJson, ...json }

        ações = açõesCustomizadas
    }

    for (let ação of ações) {
        if (ação == 'fechar_último_modal') {
            await fecharÚltimoModal({ force: true })
        } else if (ação == 'fechar_último_modal_em_desktop_ou_voltar_em_mobile') {
            if (mobile()) {
                window.history.back()
            } else {
                await fecharÚltimoModal({ force: true })
            }
        } else if (ação == 'fechar_modais_de_edição') {
            await fecharModaisDeEdição({ force: true })
        } else if (ação == 'recarregar_último_modal') {
            await recarregarÚltimoModal()
        } else if (ação == 'reload_last_modal') {
            await recarregarÚltimoModal()
        } else if (ação == 'recarregar_página_atual') {
            await visitarPágina(document.location.href)
        } else if (ação == 'recarregar_página_atual_sem_filtros') {
            await visitarPágina(document.location.pathname)
        } else if (ação == 'hard_refresh') {
            window.location.reload()
        } else if ('open_modal' in ação) {
            abrirModalUrl(ação.open_modal, ação.opts)
        } else if ('dispatch' in ação) {
            let detail = ação.detail || {}
            document.dispatchEvent(new CustomEvent(ação.dispatch, { detail: { ...detail, ...mergedJson } }))
        } else if ('toast' in ação) {
            toast(ação.toast, ação.texto, ação.opts)
        } else if ('redirect' in ação) {
            fecharModais()
            visitarPágina(ação.redirect)
        }
    }
}

export function extrairJson(changeset, chave) {
    for (let ação of changeset.ações) {
        if (typeof ação == 'string') {
            continue
        }

        if ('json' in ação && ação.json[chave]) {
            return ação.json[chave]
        }
    }
}
